import { JsToClientCommand } from '../jsToClientCommand';
import { ClientCommands } from '../clientCommands';

export type PasteClipboardContentCommandParams = {
  content: string
};

export class PasteClipboardContentCommand extends JsToClientCommand<PasteClipboardContentCommandParams> {
    constructor(params: PasteClipboardContentCommandParams) {
        super(ClientCommands.PASTE_CLIPBOARD_CONTENT, params);
    }
}
